import { Checkbox } from "@blueprintjs/core";
import { FieldArray, FormikProps } from "formik";
import { FGCustomInput, IFGFormGroupProps } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

const FieldArrayContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
`;
export interface IFGMultiCheckboxInputProps
  extends Omit<IFGFormGroupProps, "children"> {
  valueField?: string;
  displayField?: string;
  items: Array<any>;
  loading: boolean;
  readOnly?: boolean;
}

const StyledLabel = styled.div`
  margin-right: 1rem;
  margin-bottom: 2px;
`;

export const FGMultiCheckboxInput: React.FunctionComponent<
  IFGMultiCheckboxInputProps
> = ({
  items,
  name,
  label,
  valueField = "idValue",
  displayField = "displayValue",
  readOnly = false,
}) => {
  const OnCheckboxClick = React.useCallback(
    (formik: FormikProps<any>, value: any) => {
      let formikValues = formik.values[name] ?? [];
      if (formikValues.some((fv) => fv === value)) {
        formikValues = formikValues.filter((fv) => fv !== value);
      } else {
        formikValues.push(value);
      }
      formik.setFieldValue(name, [...formikValues]);
    },
    [name]
  );
  return (
    <FGCustomInput name={name} label={label}>
      {({ formik }) => (
        <FieldArray
          name={name}
          render={() => {
            return (
              <FieldArrayContainer>
                {items?.map((l, index) => (
                  <>
                    <Checkbox
                      checked={formik?.values?.[name]?.some(
                        (c) => c === +l[valueField]
                      )}
                      onClick={() => OnCheckboxClick(formik, +l[valueField])}
                      key={index}
                      disabled={readOnly}
                    />
                    <StyledLabel>{l[displayField]}</StyledLabel>
                  </>
                ))}
              </FieldArrayContainer>
            );
          }}
        />
      )}
    </FGCustomInput>
  );
};
